<template>
    <div class="line-with-dots">
        <div class="line-with-dots-elements">
            <span class="circle" />
            <span class="line" />
            <span class="circle" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "LineWithDots",
        props: ['width']
    }
</script>

<style lang="scss">
    .line-with-dots {
        width: 0;
        overflow: hidden;
        height: auto;
        transition: all 500ms ease-in-out;

        &.st-50 {
            width: 50px;
            margin: 0 10px;
        }

        &.st-200 {
            width: 200px;
            margin: 0 10px;
        }

        .line-with-dots-elements {
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;

            .circle {
                width: 7px;
                height: 7px;
                min-width: 7px;
                min-height: 7px;
                border: 1px solid white;
                border-radius: 7px;
                display: inline-block;
            }

            .line {
                display: inline-block;
                width: 95%;
                height: 1px;
                background: white;
            }
        }
    }
</style>